import axios from "axios";
import { baseUrl } from "../util";

export const getIngoingOutgoingTotal = ({
  businessId,
  setTotalObj = function () {
    return;
  },
  setData = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/ingoing-outgoing-total",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setData(response.data.data);
      setTotalObj(response.data.total_obj);
    })
    .catch(function (error) {
      console.log(error);
    });
};
